(function () {

    // @ngInject
    function CompanySettingsTeamControllerCtor($scope, $injector) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsTeamController';
    }

    Controllers.CompanySettingsTeamController = Class(Controllers.BaseController, {
        constructor: CompanySettingsTeamControllerCtor,
    });

}());
